import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import CaptionFont from '../../../../Theme/Fonts/Caption'
import TeamFormCompetition from '../Competition'
import Image from '../../../../BaseComponents/Image'
import VerticalSpacer from '../../../../Layouts/Spacer/Vertical'
import { FormItemType } from '../../../Standings/HelperClass/FormItem'

type VerticalFormMatchProps = {
    competitorImageUrl?: string
    competitorImageAlt?: string
    competitionImageUrl?: string
    competitionImageAlt?: string
    result: string
    form: FormItemType
    onPressMatch?: () => void
    onPressCompetition?: () => void
}

const getPositionTop = (form: FormItemType): number => {
    if (form === 'WIN') return 32
    if (form === 'DRAW') return 62
    return 92
}

const VerticalFormMatch: FunctionComponent<VerticalFormMatchProps> = ({
    competitorImageUrl,
    competitorImageAlt,
    competitionImageUrl,
    competitionImageAlt,
    result,
    form,
    onPressMatch,
    onPressCompetition,
}) => {
    return (
        <Grid noExpand centerHorizontal>
            <Grid position="relative" noExpand height={110} width="100%">
                <Touchable onPress={onPressMatch} expand>
                    <CaptionFont>{result}</CaptionFont>
                    <VerticalSpacer space="standard" backgroundColor="pearl" />
                    <Grid
                        position="absolute"
                        top={getPositionTop(form) - 6}
                        noExpand
                        width={24}
                        height={24}
                        backgroundColor="pearl"
                        center
                        borderRadius={12}
                        zIndex={1}
                    >
                        <Image
                            imageUrl={competitorImageUrl}
                            alt={competitorImageAlt}
                            width={16}
                            aspectRatio="1:1"
                            size="S"
                        />
                    </Grid>
                </Touchable>
            </Grid>
            <Grid paddingTop={4}>
                <Touchable onPress={onPressCompetition}>
                    <TeamFormCompetition imageUrl={competitionImageUrl} alt={competitionImageAlt} />
                </Touchable>
            </Grid>
        </Grid>
    )
}
export default VerticalFormMatch
